module.exports = __webpack_public_path__ + "img/9788993094848.9a81e67d.jpg";